import React from "react";


/***********************************************************************************************************
The Square component is rendered by the Board component. It receives props: value, onClick, and className
*/

function Square (props) {
    // return a single button which is a square on the board
      return (
        <button 
            className={props.className}      // re-render square when button clicked
            onClick={props.onClick}          // the onClick function is passed to us by the board component (contained in Game)
        >                                      
          {props.value}             
        </button>                            // the value of the square (X or O) is passed to us as a prop
      );
    }

    export default Square;